import { CheckStatus, Parse } from '../utils/ajax';
import { stringify } from 'query-string';

export default {

    save: (request, tenantId, authenticationToken) => fetch('/api/draw/1/element/type', {
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ManyWhoTenant: tenantId,
            Authorization: authenticationToken,
        },
        body: JSON.stringify(request),
    })
        .then(CheckStatus)
        .then(Parse),

    get(id, authenticationToken, tenantId) {
        return fetch(`/api/draw/1/element/type/${id}`, {
            headers: {
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getList: (authenticationToken, tenantId, filters) => {

        // Convert search filter to a format the API understands
        if (filters && filters.search) {
            filters.filter = `substringof(developerName, '${filters.search}')`;
            delete filters.search;
        }
        const params = stringify(filters);
        const query = params ? `?${params}` : '';

        return fetch(`/api/draw/1/element/type${query}`, {
            method: 'get',
            headers: {
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },


    getAll(authenticationToken, tenantId) {
        return fetch('/api/draw/1/element/type', {
            headers: {
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },
};
